export const GET_SETTING_REQUEST = 'GET_SETTING_REQUEST';
export const GET_SETTING_OBJECT_REQUESTING = 'GET_SETTING_OBJECT_REQUESTING';
export const GET_SETTING_SUCCESS = 'GET_SETTING_SUCCESS';
